// extracted by mini-css-extract-plugin
export default {"wrapper":"create_user_wrapper__rPNc2","list":"create_user_list__VSWGu","title":"create_user_title__5g0EN"};